import React, { useState } from "react";
import { Formik, Form, Field } from "formik";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Collapse,
  Checkbox,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Avatar,
} from "@mui/material";
import { format } from "date-fns";
import { useSelector } from "react-redux";
import axios from "axios";
import NotificationSnackbar from "../../../common/notificationBar/notification-snackbar";
import CreateEditDialog from "../../../common/dialog/create-edit-dialog";
import KitchenChecklist from "./tasksDialogs/kitchen-checklist";
import FridgeTemperature from "./tasksDialogs/fridge-temperature";
import WaterTemperature from "./tasksDialogs/water-temperature";
import WeeklyBedroomCheck from "./tasksDialogs/weekly-bedroom-check";
import SignInSheet from "./tasksDialogs/signIn-sheet";
import WeeklyVehicleInspect from "./tasksDialogs/weekly-vehicle-inspect";
import WeeklyFirstAidChecklist from "./tasksDialogs/weekly-firstaid-check";
import WeeklyBuildingAudit from "./tasksDialogs/weekly-building-audit";
import WeeklyCoshhProductCheck from "./tasksDialogs/weekly-cosh-product-check";
import WeeklyActivityPlanner from "./tasksDialogs/weekly-activity-planner";
import PocketMoneyRecord from "./tasksDialogs/pocket-money-record";
import ShowerDescalingLog from "./tasksDialogs/shower-descaling-log";
import SupportStatement from "../../logs/supportStatement/support-statement";
import ChildDebrief from "../../logs/childDebrief/child-debrief";
import StaffDebrief from "../../logs/staffDebrief/staff-debrief";
import RoomSearch from "../../logs/roomSearch/room-search";

const SupportTaskCard = ({
  tasks,
  updateTask,
  onTaskClick,
  refreshTasks,
  setOpenSnackbar,
  statements,
  childDebriefs,
  roomSearches,
  staffDebriefs,
}) => {
  const user = useSelector((state) => state.auth.user);
  const [expandedTask, setExpandedTask] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [checkDialogOpen, setCheckDialogOpen] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [openError, setOpenError] = useState(false);
  const [messageError, setMessageError] = useState("");
  const [dialogType, setDialogType] = useState(null);
  const [openDefaultSnackbar, setOpenDefaultSnackbar] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isChildDialogOpen, setIsChildDialogOpen] = useState(false);
  const [isStaffDialogOpen, setIsStaffDialogOpen] = useState(false);
  const [isRoomDialogOpen, setIsRoomDialogOpen] = useState(false);

  const handleToggleExpand = (index) => {
    setExpandedTask(expandedTask === index ? null : index);
  };

  const updateSubTask = async (taskId, updatedChecklist) => {
    try {
      await axios.put(
        `/api/assessments/updateTask/${taskId}`,
        {
          status: "completed",
          checklist: updatedChecklist,
          updated_by: user?.username,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-user-role": user?.roleid,
          },
        }
      );
      setDialogOpen(false);
      refreshTasks();
    } catch (error) {
      // Extract error message
      const errorMessage = error.response?.data?.message;

      // Show notification
      setOpenError(true);
      setMessageError(errorMessage);
    }
  };

  const message =
    dialogType === "kitchen"
      ? "Kitchen Checklist Task Completed Successfully."
      : dialogType === "fridge"
      ? "Fridge Temperature Task Completed Successfully."
      : dialogType === "sign"
      ? "SignIn Task Completed Successfully."
      : dialogType === "water"
      ? "Water Temperature Task Completed Successfully."
      : dialogType === "bedroom"
      ? "Weekly Bedroom Task Completed Successfully."
      : dialogType === "vehicle"
      ? "Weekly Vehicle Task Completed Successfully."
      : dialogType === "aid"
      ? "Weekly First Aid Task Completed Successfully."
      : dialogType === "audit"
      ? "Weekly Building Audit Task Completed Successfully."
      : dialogType === "product"
      ? "Weekly COSHH Product Check Task Completed Successfully."
      : dialogType === "activity"
      ? "Weekly Activity Task Completed Successfully."
      : dialogType === "pocket"
      ? "Pocket Money Record Task Completed Successfully."
      : dialogType === "shower"
      ? "Shower Descaling Log Task Completed Successfully."
      : "Unknown dialog type.";

  const dialogComponents = {
    kitchen: KitchenChecklist,
    fridge: FridgeTemperature,
    water: WaterTemperature,
    bedroom: WeeklyBedroomCheck,
    sign: SignInSheet,
    vehicle: WeeklyVehicleInspect,
    aid: WeeklyFirstAidChecklist,
    audit: WeeklyBuildingAudit,
    product: WeeklyCoshhProductCheck,
    activity: WeeklyActivityPlanner,
    pocket: PocketMoneyRecord,
    shower: ShowerDescalingLog,
  };

  const SelectedComponent = dialogComponents[dialogType] || null;

  const handleTaskClick = (task) => {
    setSelectedTask(task);
    setIsDialogOpen(true);
  };

  const handleDialogClose = () => {
    setIsDialogOpen(false);
    setSelectedTask(null);
  };

  const handleChildTaskClick = (task) => {
    setSelectedTask(task);
    setIsChildDialogOpen(true);
  };

  const handleRoomTaskClick = (task) => {
    setSelectedTask(task);
    setIsRoomDialogOpen(true);
  };

  const handleRoomDialogClose = () => {
    setIsRoomDialogOpen(false);
    setSelectedTask(null);
  };

  const handleChildDialogClose = () => {
    setIsChildDialogOpen(false);
    setSelectedTask(null);
  };

  const handleStaffTaskClick = (task) => {
    setSelectedTask(task);
    setIsStaffDialogOpen(true);
  };

  const handleStaffDialogClose = () => {
    setIsStaffDialogOpen(false);
    setSelectedTask(null);
  };
  return (
    <Box sx={{ mb: 4 }}>
      {tasks.map((task, index) => {
        return (
          <Formik
            key={task.id}
            initialValues={{ task }}
            onSubmit={async (values, { setSubmitting }) => {
              try {
                const validChecklist = (task.checklist || []).filter((item) => item && item?.item);
                const updatedChecklist = validChecklist.map((item) => ({ ...item, status: "true" }));

                await updateTask(task.id, null, null, "completed", updatedChecklist);
                alert("Task and subtasks updated to completed!");
                refreshTasks();
              } catch (error) {
              } finally {
                setSubmitting(false);
              }
            }}
          >
            {() => (
              <Form>
                <Card
                  sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
                  onClick={() => {
                    onTaskClick(task); // Trigger the task click handler
                    handleToggleExpand(index); // Toggle expansion for the task
                    setSelectedTask(task);
                    // Open the dialog only if it's not already open
                    if (
                      !checkDialogOpen &&
                      task?.checklist?.length === 0 &&
                      task.status === "pending" &&
                      task.taskType === "default"
                    ) {
                      const dialogMapping = {
                        kitchen: "kitchen",
                        fridge: "fridge",
                        water: "water",
                        bedroom: "bedroom",
                        sign: "sign",
                        vehicle: "vehicle",
                        aid: "aid",
                        audit: "audit",
                        product: "product",
                        activity: "activity",
                        pocket: "pocket",
                        shower: "shower",
                      };

                      const taskNameLower = task.taskName.toLowerCase();
                      const matchedType = Object.entries(dialogMapping).find(([key]) =>
                        taskNameLower.includes(key)
                      )?.[1];

                      if (matchedType && task.assignee === user.username) {
                        setDialogType(matchedType);
                        setCheckDialogOpen(true);
                      } else {
                        setDialogType(null);
                        setCheckDialogOpen(false);
                      }
                    }
                  }}
                >
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item lg={10} xs={9}>
                        <Grid container spacing={1} mb={1}>
                          <Grid item>
                            <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                              {task.taskName}
                            </Typography>
                          </Grid>
                        </Grid>
                        <Typography sx={{ fontSize: "12px", color: "black" }}>{task.description}</Typography>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor: task.status === "completed" ? "#EAFFF2" : "#F2F6FF",
                              color: task.status === "completed" ? "green" : "blue",
                            }}
                            label={task.status}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                      <Grid item lg={2} md={3}>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                          </Grid>
                          <Grid item>
                            <Chip
                              variant='contained'
                              sx={{
                                fontSize: "12px",
                                borderRadius: 5,
                                backgroundColor:
                                  task.assignee && task.assignee !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                                color: task.assignee && task.assignee !== "unassigned" ? "green" : "blue",
                              }}
                              label={task.assignee ?? "unassigned"}
                              size='small'
                            />
                          </Grid>
                        </Grid>
                        <br />
                        <Typography sx={{ fontSize: "12px" }}>
                          {task?.timeline === "daily"
                            ? format(new Date(task.created_at), "dd EEE")
                            : `${format(new Date(task.created_at), "dd EEE")} - ${format(
                                new Date(new Date(task.created_at).setDate(new Date(task.created_at).getDate() + 6)),
                                "dd EEE"
                              )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                    <Collapse in={expandedTask === index}>
                      <Box mt={2}>
                        {(task.checklist || [])
                          .filter((item) => item && item?.item)
                          .map((item, subIndex) => (
                            <Card
                              key={subIndex}
                              sx={{
                                ml: 2,
                                bgcolor: "#f9f9f9",
                                color: "#000",
                                padding: 2,
                                borderRadius: 0,
                              }}
                              onClick={(e) => e.stopPropagation()}
                            >
                              <Grid container justifyContent='space-between'>
                                <Grid item>
                                  <Typography sx={{ fontSize: "12px" }}>
                                    <Field
                                      as={Checkbox}
                                      name={`task.checklist[${subIndex}].status`}
                                      checked={item?.status === "true"}
                                      size='small'
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        setDialogOpen(true);
                                        // Ensure `setCurrentItem` is always assigned a valid object
                                        if (item) {
                                          setCurrentItem(item);
                                        }
                                      }}
                                      disabled={task.status === "completed"}
                                    />
                                    {item?.item}
                                  </Typography>
                                </Grid>
                                <Grid item>
                                  <Typography sx={{ fontSize: "12px" }}>
                                    {item?.status === "true" ? "Completed" : "Still not completed"}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Card>
                          ))}
                      </Box>
                    </Collapse>
                    <CreateEditDialog isOpen={checkDialogOpen} maxWidth='lg' onClose={() => setCheckDialogOpen(false)}>
                      {SelectedComponent && (
                        <SelectedComponent
                          onClose={() => setCheckDialogOpen(false)}
                          setOpenDefaultSnackbar={setOpenDefaultSnackbar}
                          selectedTask={selectedTask} // Pass selected task
                        />
                      )}
                    </CreateEditDialog>

                    <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                      <DialogTitle>Confirm Action</DialogTitle>
                      <DialogContent>
                        <Typography>Are you sure you want to mark this task as completed</Typography>
                      </DialogContent>
                      <DialogActions>
                        <Button
                          onClick={() => {
                            setDialogOpen(false);
                            refreshTasks();
                          }}
                          variant='contained'
                          sx={{ textTransform: "none" }}
                        >
                          Cancel
                        </Button>

                        <Button
                          onClick={() => {
                            const newChecklist = task.checklist.map((item) =>
                              item?.item === currentItem?.item
                                ? { ...item, status: currentItem.status === "true" ? "false" : "true" }
                                : item
                            );

                            setOpenSnackbar(true);

                            updateSubTask(
                              selectedTask?.id, // Use safe access
                              newChecklist
                            );

                            setDialogOpen(false); // Close dialog after action
                          }}
                          variant='contained'
                          sx={{ textTransform: "none" }}
                        >
                          Proceed
                        </Button>
                      </DialogActions>
                    </Dialog>
                  </CardContent>
                </Card>
              </Form>
            )}
          </Formik>
        );
      })}

      {statements?.map((statement, index) => {
        return (
          <Formik key={statement.id} initialValues={{ statement }} onSubmit={() => {}}>
            {() => (
              <Form>
                <Card
                  sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
                  onClick={() => handleTaskClick(statement)}
                >
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item lg={10} xs={9}>
                        <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                          {statement.taskName}
                        </Typography>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor: statement.status === "completed" ? "#EAFFF2" : "#F2F6FF",
                              color: statement.status === "completed" ? "green" : "blue",
                            }}
                            label={statement.status}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                      <Grid item lg={2} md={3}>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                          </Grid>
                          <Grid item>
                            <Chip
                              variant='contained'
                              sx={{
                                fontSize: "12px",
                                borderRadius: 5,
                                backgroundColor:
                                  user.username && user.username !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                                color: user.username && user.username !== "unassigned" ? "green" : "blue",
                              }}
                              label={user.username ?? "unassigned"}
                              size='small'
                            />
                          </Grid>
                        </Grid>
                        <br />
                        <Typography sx={{ fontSize: "12px" }}>
                          {`${format(new Date(statement.created_at), "dd EEE")} - ${format(
                            new Date(
                              new Date(statement.created_at).setDate(new Date(statement.created_at).getDate() + 2)
                            ),
                            "dd EEE"
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Form>
            )}
          </Formik>
        );
      })}
      <CreateEditDialog isOpen={isDialogOpen} maxWidth='lg' onClose={handleDialogClose}>
        <SupportStatement handleDialogClose={handleDialogClose} selectedTask={selectedTask} />
      </CreateEditDialog>

      {staffDebriefs?.map((staff, index) => {
        return (
          <Formik key={staff.id} initialValues={{ staff }} onSubmit={() => {}}>
            {() => (
              <Form>
                <Card
                  sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
                  onClick={() => handleStaffTaskClick(staff)}
                >
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item lg={10} xs={9}>
                        <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                          {staff.taskName}
                        </Typography>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor: staff.status === "completed" ? "#EAFFF2" : "#F2F6FF",
                              color: staff.status === "completed" ? "green" : "blue",
                            }}
                            label={staff.status}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                      <Grid item lg={2} md={3}>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                          </Grid>
                          <Grid item>
                            <Chip
                              variant='contained'
                              sx={{
                                fontSize: "12px",
                                borderRadius: 5,
                                backgroundColor:
                                  user.username && user.username !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                                color: user.username && user.username !== "unassigned" ? "green" : "blue",
                              }}
                              label={user.username ?? "unassigned"}
                              size='small'
                            />
                          </Grid>
                        </Grid>
                        <br />
                        <Typography sx={{ fontSize: "12px" }}>
                          {`${format(new Date(staff.created_at), "dd EEE")} - ${format(
                            new Date(new Date(staff.created_at).setDate(new Date(staff.created_at).getDate() + 2)),
                            "dd EEE"
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Form>
            )}
          </Formik>
        );
      })}
      <CreateEditDialog isOpen={isStaffDialogOpen} maxWidth='lg' onClose={handleStaffDialogClose}>
        <StaffDebrief handleStaffDialogClose={handleStaffDialogClose} selectedTask={selectedTask} />
      </CreateEditDialog>

      {childDebriefs?.map((child, index) => {
        return (
          <Formik key={child.id} initialValues={{ child }} onSubmit={() => {}}>
            {() => (
              <Form>
                <Card
                  sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
                  onClick={() => handleChildTaskClick(child)}
                >
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item lg={10} xs={9}>
                        <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                          {child.taskName}
                        </Typography>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor: child.status === "completed" ? "#EAFFF2" : "#F2F6FF",
                              color: child.status === "completed" ? "green" : "blue",
                            }}
                            label={child.status}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                      <Grid item lg={2} md={3}>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                          </Grid>
                          <Grid item>
                            <Chip
                              variant='contained'
                              sx={{
                                fontSize: "12px",
                                borderRadius: 5,
                                backgroundColor:
                                  user.username && user.username !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                                color: user.username && user.username !== "unassigned" ? "green" : "blue",
                              }}
                              label={user.username ?? "unassigned"}
                              size='small'
                            />
                          </Grid>
                        </Grid>
                        <br />
                        <Typography sx={{ fontSize: "12px" }}>
                          {`${format(new Date(child.created_at), "dd EEE")} - ${format(
                            new Date(new Date(child.created_at).setDate(new Date(child.created_at).getDate() + 2)),
                            "dd EEE"
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Form>
            )}
          </Formik>
        );
      })}
      <CreateEditDialog isOpen={isChildDialogOpen} maxWidth='lg' onClose={handleChildDialogClose}>
        <ChildDebrief handleChildDialogClose={handleChildDialogClose} selectedTask={selectedTask} />
      </CreateEditDialog>

      {roomSearches?.map((room, index) => {
        return (
          <Formik key={room.id} initialValues={{ room }} onSubmit={() => {}}>
            {() => (
              <Form>
                <Card
                  sx={{ mb: 2, color: "#ECECED", cursor: "pointer", border: "1px solid #ddd" }}
                  onClick={() => handleRoomTaskClick(room)}
                >
                  <CardContent>
                    <Grid container spacing={1}>
                      <Grid item lg={10} xs={9}>
                        <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold" }}>
                          {room.taskName}
                        </Typography>
                        <Grid item>
                          <Chip
                            variant='contained'
                            sx={{
                              fontSize: "12px",
                              borderRadius: 5,
                              backgroundColor: room.status === "completed" ? "#EAFFF2" : "#F2F6FF",
                              color: room.status === "completed" ? "green" : "blue",
                            }}
                            label={room.status}
                            size='small'
                          />
                        </Grid>
                      </Grid>
                      <Grid item lg={2} md={3}>
                        <Grid container spacing={1}>
                          <Grid item>
                            <Avatar alt='Profile' src={""} className='profile-avatar' sx={{ width: 30, height: 30 }} />
                          </Grid>
                          <Grid item>
                            <Chip
                              variant='contained'
                              sx={{
                                fontSize: "12px",
                                borderRadius: 5,
                                backgroundColor:
                                  user.username && user.username !== "unassigned" ? "#EAFFF2" : "#F2F6FF",
                                color: user.username && user.username !== "unassigned" ? "green" : "blue",
                              }}
                              label={user.username ?? "unassigned"}
                              size='small'
                            />
                          </Grid>
                        </Grid>
                        <br />
                        <Typography sx={{ fontSize: "12px" }}>
                          {`${format(new Date(room.created_at), "dd EEE")} - ${format(
                            new Date(new Date(room.created_at).setDate(new Date(room.created_at).getDate() + 2)),
                            "dd EEE"
                          )}`}
                        </Typography>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Form>
            )}
          </Formik>
        );
      })}
      <CreateEditDialog isOpen={isRoomDialogOpen} maxWidth='lg' onClose={handleRoomDialogClose}>
        <RoomSearch handleRoomDialogClose={handleRoomDialogClose} selectedTask={selectedTask} />
      </CreateEditDialog>

      {/* Notification Snackbar */}
      <NotificationSnackbar open={openError} onClose={() => setOpenError(false)} color='error' message={messageError} />
      <NotificationSnackbar
        open={openDefaultSnackbar}
        onClose={() => setOpenDefaultSnackbar(false)}
        color='success'
        message={message}
      />
    </Box>
  );
};

export default SupportTaskCard;
